export default "__VITE_ASSET__CHJuY0tA__"